// extracted by mini-css-extract-plugin
export default {"oldImageContainer":"style_oldImageContainer__trjGN","p0":"style_p0__ZeXrC","imageIcon":"style_imageIcon__99hTG"};